import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { i18n } from 'config/locales';

import { saveRequest } from '@redux/modules/save/actions';
import { getSectionKeys } from '@redux/modules/section/selectors';
import { Modal } from '../../Modal';
import SvgComponent from '../SvgComponent';
import { renewSessionRequest } from '../../../redux/modules/authentication/actions';

export class TimeoutWarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countdown: 60,
    };

    // create a ref to store the button DOM element
    this.timeoutButton = React.createRef();

    this.interval = 1000; // tick every second
    this.timer = null;
  }

  componentDidMount() {
    if (this.timeoutButton.current) {
      this.timeoutButton.current.focus();
    }

    this.resetInterval();
    this.autosave();
  }

  componentWillUnmount() {
    window.clearInterval(this.timer);
  }

  onClick = () => {
    this.props.dispatch(renewSessionRequest());
  };

  autosave = () => {
    const { sectionKey, subsectionKey, dispatch } = this.props;

    dispatch(saveRequest(sectionKey, subsectionKey, false));
  };

  tick = () => {
    const { countdown } = this.state;
    const newCountdown = countdown - 1;

    if (newCountdown >= 0) {
      this.setState({
        countdown: newCountdown,
      });
    }
  };

  resetInterval = () => {
    if (this.timer) { window.clearInterval(this.timer); }
    this.timer = window.setInterval(this.tick, this.interval);
  };

  render() {
    const { countdown } = this.state;

    const message = i18n.t('application.timeout.message').replace('{time}', countdown);

    // For screen readers, report count down to timeout in 10 second intervalss
    const ariaCountdown = countdown ? `${(`${countdown + 9}`).charAt(0)}0` : '';
    const ariaLabel = i18n.t('application.timeout.aria').replace('{time}', ariaCountdown);

    return (
      <Modal show className="timeout-warning-modal">
        <div className="timeout-content">
          <SvgComponent src="/img/timeout-icon.svg" />
          <h2>{i18n.t('application.timeout.title')}</h2>
          <p aria-hidden>{message}</p>
          <button
            ref={this.timeoutButton}
            type="button"
            title={i18n.t('application.timeout.button')}
            aria-label={ariaLabel}
            onClick={this.onClick}
          >
            <span>{i18n.t('application.timeout.button')}</span>
            <div className="arrow-circle-right">
              <SvgComponent className="arrow-circle-right" src="/img/arrow-circle-right.svg" />
            </div >
          </button>
        </div>
      </Modal>
    );
  }
}

TimeoutWarning.propTypes = {
  sectionKey: PropTypes.string,
  subsectionKey: PropTypes.string,
  dispatch: PropTypes.func,
};

TimeoutWarning.defaultProps = {
  dispatch: () => { },
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  ...getSectionKeys(state),
});

export default connect(mapStateToProps)(TimeoutWarning);
